import { Button, Modal, Select, Typography } from 'antd';
import { useState } from 'react';
import { useExportHistoryMutation } from '../api/rendersApiSlice';
import { usePrerenderEmail } from '../../hooks/usePrerenderUser';
import { Link } from 'react-router-dom';

const selectIntervalOptions = [
  { value: '1day', label: 'Past 24 hours' },
  { value: '7days', label: 'Past 7 days' },
  { value: '30days', label: 'Past 30 days' },
];

const selectFileTypeOptions = [
  { value: 'csv', label: 'CSV file' },
  // { value: 'excel', label: 'Spreadsheet (XLSX - Max 65536 rows of data allowed)' },
];

const mapExportAnalyticsResponseStatusToUserText = (status, prerenderEmail) => {
  switch (status) {
    case 'queued':
      return <Typography.Paragraph>We will email a download link to <strong>{prerenderEmail}</strong> when your export is ready. You can also access it from the <Link to="/notifications">Notifications Center</Link>.</Typography.Paragraph>;
    case 'already exists':
      return <Typography.Paragraph>You already have an export in progress. We will email you a download link at <strong>{prerenderEmail}</strong> when the export is ready. You can also find it on your <Link to="/notifications">Notifications Center</Link>.</Typography.Paragraph>;
    default:
      return <Typography.Paragraph>Something bad has happened. We're looking into it...</Typography.Paragraph>;
  }
};

const NewExportRenderHistoryModal = ({ visible, setVisible, params }) => {
  const [userInput, setUserInput] = useState({
    interval: selectIntervalOptions[0].value,
    fileType: selectFileTypeOptions[0].value,
  });
  const [exportCSV, exportCSVStatus] = useExportHistoryMutation();
  const prerenderEmail = usePrerenderEmail();

  const appendUserInput = (newInput) => {
    setUserInput((prevInput) => ({ ...prevInput, ...newInput }));
  };

  const modalTitle =
    exportCSVStatus.isSuccess && exportCSVStatus.data?.status === 'queued'
      ? 'Render History export scheduled'
      : 'Export Render History';

  return (
    <Modal
      open={visible}
      title={modalTitle}
      okText="Export"
      onCancel={() => setVisible(false)}
      onOk={() => {
        exportCSV({ ...userInput, ...params });
      }}
      footer={
        exportCSVStatus.isSuccess
          ? [
              <Button key="close" type="primary" onClick={() => setVisible(false)}>
                Close
              </Button>,
            ]
          : undefined
      }
    >
      {exportCSVStatus.isSuccess ? (
          mapExportAnalyticsResponseStatusToUserText(exportCSVStatus.data.status, prerenderEmail)
      ) : exportCSVStatus.isError ? (
        <Typography.Paragraph type="danger">{exportCSVStatus.error.message}</Typography.Paragraph>
      ) : (
        <>
          <p>Select Report Interval</p>
          <Select
            options={selectIntervalOptions}
            defaultValue={selectIntervalOptions[0].value}
            className="w-100 no-border"
            onChange={(value) => appendUserInput({ interval: value })}
          />
          <p>Select Report Type</p>
          <Select
            options={selectFileTypeOptions}
            defaultValue={selectFileTypeOptions[0].value}
            className="w-100 no-border"
            onChange={(value) => appendUserInput({ fileType: value })}
          />
        </>
      )}
    </Modal>
  );
};

export default NewExportRenderHistoryModal;
